import { hideModal } from 'managers/modal'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import { formFieldProps } from 'utils/form'
import { createValidationSchema, optional } from 'utils/validations'
import { UIButton } from 'components/ui/Button'
import { useState } from 'react'
import { showSuccessToast } from 'utils/toast'
import { closeTicket } from 'api/tickets'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TextArea } from 'components/ui/TextArea'

type CloseTicketModalProps = {
  onSuccess?: () => void
  ticketId: string
}

export const CloseTicketModal = ({ onSuccess, ticketId }: CloseTicketModalProps) => {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  const { values, errors, setFieldValue, setFieldError, handleSubmit } = useFormik({
    initialValues: {
      closingReason: '',
    },
    validationSchema: createValidationSchema({
      closingReason: optional,
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      console.debug({ values })
      try {
        setLoading(true)
        await closeTicket(ticketId, values.closingReason)
        onSuccess?.()
        showSuccessToast(t('tickets.closedSuccess'))
        hideModal()
      } catch (e) {
        console.error({ e })
      } finally {
        setLoading(false)
      }
    },
  })

  // const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
  //   if (e.key === 'Enter') {
  //     handleSubmit()
  //   }
  // }

  const fieldProps = formFieldProps(errors, values, setFieldError, setFieldValue)

  return (
    <div style={{ padding: 20 }}>
      <div className={'tw-flex tw-flex-row tw-items-center tw-justify-between'}>
        <div className={'tw-font-[800]'}>{t('closeTicket')}</div>
        <div className={'tw-cursor-pointer'}>
          <FontAwesomeIcon icon={['far', 'times']} onClick={hideModal} />
        </div>
      </div>
      <div className={'tw-flex tw-flex-col tw-space-y-1 tw-mt-2'}>
        <TextArea label={t('tickets.closingReason')} {...fieldProps('closingReason')} />
      </div>
      <div className={'tw-mt-6 tw-w-full'}>
        <UIButton className={'tw-w-full'} onClick={() => handleSubmit()} loading={loading}>
          <span className={'tw-text-sm'}>{t('closeTicket')}</span>
        </UIButton>
      </div>
    </div>
  )
}
